import request from '../utils/request'
const serviceName = 'baseUser'

export function getUserList(data) {
  return request({
    url:`/${serviceName}/getUserList`,
    method:'post',
    data
  })
}

export function getSeverData() {
  return request({
    url:'/sso/distribute/server',
    method:'get'
  })
}

export function getTyList() {
    return request({
        url:`/category/getCategoryList/key?value=human_type`,
        method:'get',

    })
}

export function addOrUpdateUser(newFormFlag, data) {
  var url
  if (newFormFlag) {
    url = 'addUser'
  } else {
    url = 'updateUser'
  }
  return request({
    url:`/${serviceName}/${url}`,
    method:'post',
    data
  })
}

export function deleteUser(data) {
  return request({
    url:`/${serviceName}/deleteUser`,
    method:'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url:`/${serviceName}/resetPassword`,
    method:'post',
    data
  })
}

export function setStatus(data) {
  return request({
    url:`/${serviceName}/setStatus`,
    method:'post',
    data
  })
}

export function changeOrgByUsers(data) {
  return request({
    url:`/${serviceName}/changeOrgByUsers`,
    method:'post',
    data
  })
}

export function UsersToRoles(data) {
  return request({
    url:`/${serviceName}/UsersToRoles`,
    method:'post',
    data
  })
}

export function UsersToRolesForOne(data) {
  return request({
    url:`/${serviceName}/UsersToRolesForOne`,
    method:'post',
    data
  })
}

export function distributeUser(data) {
  return request({
    url:`/sso/distribute/user`,
    method:'post',
    data
  })
}

export function deleteImg(data) {
  return request({
    url:`/${serviceName}/deleteImg`,
    method:'post',
    data
  })
}

export function relOrg(userId, proId) {
    return request({
        url:`/${serviceName}/assignPro2User?userId=${userId}&proId=${proId}`,
        method:'post'
    })
}

export function getProByUserId(userId) {
    return request({
        url:`/${serviceName}/getProByUserId?userId=${userId}`,
        method:'post'
    })
}

export function addUser(data) {
  return request({
      url:`/project-sync/addUser`,
      method:'post',
      data:data
  })
}





// WEBPACK FOOTER //
// ./src/api/baseUser.js